import styled, { css } from "styled-components";

//----------------------------------------------font family variables----------------------------------------------
export const fontFamilies = {
  /* fonts  */
  headingFont: "Roboto Condensed, Sans-Serif",
  bodyFont: "Cabin, Sans-Serif",
  landrinaFont: "Londrina Shadow, cursive",
};
//----------------------------------------------font family variables----------------------------------------------
//----------------------------------------------color variables----------------------------------------------
export const colors = {
  /* colors */
  primary50: "#eff6ff",
  primary100: "#dbeafe",
  primary200: "#bfdbfe",
  primary300: "#93c5fd",
  primary400: "#60a5fa",
  primary500: "#3b82f6",
  primary600: "#2563eb",
  primary700: "#1d4ed8",
  primary800: "#1e40af",
  primary900: "#1e3a8a",

  /* grey */
  grey50: "#f0f4f8",
  grey100: "#d9e2ec",
  grey200: "#bcccdc",
  grey300: "#9fb3c8",
  grey400: "#829ab1",
  grey500: "#627d98",
  grey600: "#486581",
  grey700: "#334e68",
  grey800: "#243b53",
  grey900: "#102a43",
  /* rest of the colors */
  black: "#000",
  white: "#ffffff",
  redLight: "#f8d7da",
  redDark: "#842029",
  redLight: "#e0296c",
  greenLight: "#d1e7dd",
  greenDark: "#0f5132",
  //   errorText: redDark,

  backgroundColor: "#f5f5f7",
  textColor: "#1d1d1f",

  /* WHITE MODE */
  //   backgroundSecondaryColor: white,
  textSecondaryColor: "#6e6e73",

  /* DARK MODE */
  darkModeBgColor: "#1b1b1b",
  darkModeTextColor: "#f0f0f0",
  darkModeBgSecondaryColor: "#3f3f3f",
  //   darkModeTextSecondaryColor: grey300,
};
//----------------------------------------------color variables----------------------------------------------
//----------------------------------------------shadow box css helper----------------------------------------------
export const shadowBox = ({
  top1,
  right1,
  bottom1,
  left1,
  color1,
  top2,
  right2,
  bottom2,
  left2,
  color2,
}) => `
shadow:${top1} ${right1} ${bottom1} ${left1} ${color1}, ${top2} ${right2}  ${bottom2} ${left2} ${color2}
`;
//----------------------------------------------shadow box css helper----------------------------------------------
//----------------------------------------------transition css helper----------------------------------------------
export const transition = css`
  transition: 0.3s ease-in-out all;
`;
//----------------------------------------------transition css helper----------------------------------------------
//----------------------------------------------font css helper----------------------------------------------
export const font = ({
  bodyFont = fontFamilies.bodyFont,
  fontWeight,
  fontSize,
  lineHeight,
  latterSpacing,
}) => css`
  font-family: ${bodyFont};
  font-weight: ${fontWeight};
  font-size: ${fontSize};
  line-height: ${lineHeight};
  letter-spacing: ${latterSpacing};
`;
//----------------------------------------------font css helper------------------------------------------------

//----------------------------------------------heading css helper---------------------------------------------
export const heading = css`
  margin: 0;
  margin-bottom: 1.38rem;
  font-family: ${({ headingFont }) => headingFont};
  font-weight: 400;
  line-height: 1.3;
  text-transform: capitalize;
  letter-spacing: ${({ letterSpacing }) => letterSpacing};
  color: ${({ textSecondaryColor }) => textSecondaryColor};
`;
//----------------------------------------------heading css helper---------------------------------------------
// const headingTypes = {
//   h1: "h1",
//   h2: "h2",
//   h3: "h3",
//   h4: "h4",
//   h5: "h5",
// };
// export const fontZise = (headingSize = headingTypes.h1) =>
//   ({
//     [headingTypes.h1]: "3.052rem",
//     [headingTypes.h2]: "2.441rem",
//     [headingTypes.h3]: "1.953rem",
//     [headingTypes.h4]: "1.563rem",
//     [headingTypes.h5]: "1.25rem",
//   }[headingSize]);

export const widthVariables = {
  maxWidth: "1120px",
  fixedWidth: "500px",
  fluidWidth: "90vw",
};
export const buttonColor = css`
  background-color: ${({ bgColor }) => bgColor};
  color: ${({ textColor }) => textColor};
`;

export const container = (
  fluidWidth = widthVariables.fluidWidth,
  maxWidth = widthVariables.maxWidth
) => `
  width: ${fluidWidth};
  max-width: ${maxWidth};
  margin: 0 auto;

`;

const baseShadow = css`
  box-shadow: ${({ color }) => `0 10px 6px -6px ${color || "#777"}`};
`;

export const responsive = {
  mobile: {
    standard: (...args) => css`
      @media (max-width: 600px) {
        ${css(...args)};
      }
    `,
  },
  tablet: {
    standard: (...args) => css`
      @media (max-width: 900px) {
        ${css(...args)}
      }
    `,
  },
  disktop: {
    standard: (...args) => css`
      @media (max-width: 1200px) {
        ${css(...args)}
      }
    `,
  },
};

export const grid = ({
  alignItem = "center",
  justifyContent = "center",
} = {}) => css`
  display: grid;
  align-items: ${alignItem};
  justify-content: ${justifyContent};
`;

export const flex = ({
  flexDirection = "column",
  justifyContent = "center",
  alignItem = "center",
} = {}) => css`
  display: flex;
  flex-direction: ${flexDirection};
  justify-content: ${justifyContent};
  align-items: ${alignItem};
`;
